import http from '@/services/http';

export interface ApiLocationNode {
  id: string;
  code: string | null;
  name: string;
  kind: string;
  active: boolean;
  parent_id: string | null;
  client: {
    id: string;
    name: string;
    active: boolean;
  } | null;
  company_profile: {
    company_name: string | null;
    address_line: string | null;
    postal_code: string | null;
    city: string | null;
    city_code: string | null;
  } | null;
  varibox_count: number;
  children: ApiLocationNode[];
}

export interface ApiLocationListResponse {
  items: ApiLocationNode[];
  total: number;
}

export interface ApiLocationDetails {
  id: string;
  code: string | null;
  name: string;
  kind: string;
  active: boolean;
  parent: {
    id: string;
    code: string | null;
    name: string;
  } | null;
  children: Array<{
    id: string;
    code: string | null;
    name: string;
    kind: string;
    active: boolean;
  }>;
  client: {
    id: string;
    name: string;
    active: boolean;
  } | null;
  company_profile: {
    company_name: string | null;
    address_line: string | null;
    postal_code: string | null;
    city: string | null;
    city_code: string | null;
  } | null;
  varibox_count: number;
  created_at: string;
  updated_at: string;
}

export interface CreateLocationPayload {
  code?: string | null;
  name: string;
  kind: 'sublocation' | 'client_node';
  active?: boolean;
  parent_id: string;
  client_id?: string | null;
  company_name?: string | null;
  address_line?: string | null;
  postal_code?: string | null;
  city?: string | null;
  city_code?: string | null;
}

export async function getLocationTree() {
  const response = await http.get<ApiLocationListResponse>('/api/locations');
  return response.data;
}

export async function getLocationDetails(id: string) {
  const response = await http.get<ApiLocationDetails>(`/api/locations/${id}`);
  return response.data;
}

export async function createLocation(payload: CreateLocationPayload) {
  const response = await http.post<ApiLocationDetails>('/api/locations', payload);
  return response.data;
}
